








































































































































import {Component, Vue} from 'vue-property-decorator'
import api from '../../../api/v2/api';

@Component
export default class MyProfileUserAccountDeletion extends Vue {
  password = '';
  confirmDelete = false;
  confirmReason = false;
  reason = '';
  otherReason = '';
  showConfirmModal = false;
  processing = false;
  showSuccessModal = false;
  showErrorModal = false;
  errorMessage = '';
  passwordError = '';

  showConfirmation() {
    if (this.password.length < 4) {
      this.passwordError = 'パスワードが正しくありません';
      return;
    }
    this.passwordError = '';
    this.showConfirmModal = true;
  }

  deleteAccount() {
    this.processing = true;
    this.showConfirmModal = false;
    api.user.destroy(this.password, this.reason, this.otherReason).then(() => {
      this.processing = false;
      this.showSuccessModal = true;
    }).catch((error) => {
      this.processing = false;
      this.showErrorModal = true;
      this.errorMessage = error.messages;
      console.error(error)
    });
  }

  goBack() {
    window.history.back();
  }

  redirectToHome() {
    window.location.href = '/';
  }

  redirectToMyProfile() {
    window.location.href = '/classroom/myprofile?section=deletion';
  }

  async mounted() {
  }
}
